import React, { useEffect, useState } from "react";
import { Form, Input } from "antd";
import { useSelector } from "react-redux";
import { getOrganizationAdmin } from "@src/redux/index";

interface AdminUserNameProps {
  mutationType?: string;
  form?: any;
  username?: string;
}

const AdminUserName: React.FC<AdminUserNameProps> = ({
  form,
  mutationType,
  username: getUsername,
}) => {
  // useEffect(() => {
  //   if (mutation_type === "edit") {
  //     if (username) {
  //       set_name(true);
  //     }
  //   }
  // }, [username, mutation_type]);

  return (
    <Form.Item
      name={["systemUser", "username"]}
      label="Username"
      rules={[{ required: true, message: "Please enter the username!" }]}
    >
      <Input disabled={getUsername ? true : false} />
    </Form.Item>
  );
};

export default AdminUserName;
